import { useEffect, useRef } from 'react';
import { useCouponRules } from '../couponRulesContext'

import { Container } from './style';

export function InputDiv({ title, explain, placeholder, inputActive, setInputText, type }) {
    const inputRef = useRef(null)

    const { inputMinValueText, inputMaxQuantityText } = useCouponRules()

    useEffect(() => {
        if(inputActive === false)
            inputRef.current.value = ''
    }, [inputActive])

    
    useEffect(() => {
        type === 'minValue' ?
        inputRef.current.value = inputMinValueText 
        :
        inputRef.current.value = inputMaxQuantityText
    }, [inputMaxQuantityText, inputMinValueText, type])

    return(
        <Container inputActive={inputActive}>
            <div>
                <strong>{title}</strong>
                <p>{explain}</p>
            </div>
            <input 
                type="number"
                placeholder={placeholder}
                onChange={event => setInputText(event.target.value)}
                ref={inputRef}
            />
        </Container>
    )
}
